// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"1a5759dd","455":"dc571d48","980":"fbb12927"}[chunkId] + ".chunk.js";
};